export const parseJSONValue = (text) => {
  try {
    return text?.value ? JSON.parse(text?.value) : text;
  } catch (e) {
    return text;
  }
};

export const getValue = (text) => {
  try {
    return text?.value ? text?.value : text;
  } catch (e) {
    return text;
  }
};
